import React from "react";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { FileOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Popconfirm, Row } from "antd";
//Ducks y utils
import * as reqDuck from "../../../../redux/aspirante/reqAcademicoDuck";
import * as utils from "../../../../utils";

/**
 * Componente que permite actualizar el documento de req. académico 
 */
export const UpdateArchivo = () => {
  const dispatch = useDispatch();
  const { updateDocumento } = useSelector((state) => state.reqAcademico);

  /**
   * Función que permite guardar en el documento del aspirante en la BD.
   * @param {object} documento
   */
  const actualizarReqAcademico = () => {
    let formData = new FormData();
    Object.entries(updateDocumento).forEach(([key, value]) => {
      if (`${key}` === "archivo") {
        //Se realiza la creación de un new File ya que al iterarlo por defecto lo obtiene como string
        const file = utils.blobToFile(value);
        //Se manda el archivo en la lista
        formData.append(`${key}`, file);
      } else {
        formData.append(`${key}`, value);
      }
    });
    //Se manda a guardar
    dispatch(reqDuck.updateArchivo(formData));
    //Se quita el documento
    dispatch(reqDuck.delDocumentoUpd());
  };

  return (
    <div className="cargar-archivo">
      <Row gutter={24}>
        <Col span={12} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          <FileOutlined /> {updateDocumento.archivo.name}
        </Col>
        <Col span={9} xxl={9} xl={9} lg={9} md={9} sm={24} xs={24}>
          <Button
            type="ghost"
            className="btn-cargar-archivo"
            onClick={() => {
              actualizarReqAcademico();
            }}
          >
            Actualizar documento
          </Button>
        </Col>
        <Col span={2} xxl={2} xl={2} lg={2} md={2} sm={24} xs={24}>
          <Popconfirm
            title={utils.INFO_ELIMINAR}
            onConfirm={() => dispatch(reqDuck.delDocumentoUpd())}
            okText="Aceptar"
            cancelText="Cancelar"
          >
            <Button
              id="bntCircle"
              shape="circle"
              icon={<DeleteOutlined />}
              style={{ marginTop: 0 }}
            />
          </Popconfirm>
        </Col>
      </Row>
    </div>
  );
};
